import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sessions: [],
  selectedSession: null,
  currentSession: null,
};

export const sessionSlice = createSlice({
  name: "sessions",
  initialState,

  reducers: {
    setSessions: (state, action) => {
      const sorted = [...action.payload].sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate),
      );

      state.sessions = sorted;
      if (sorted.length > 0) {
        const last = sorted[sorted.length - 1];
        state.selectedSession = last._id;
        state.currentSession = last;
      } else {
        state.selectedSession = null;
        state.currentSession = null;
      }
    },
    // removeSessions: (state) => {
    //   return initialState;
    // },
    removeSessions: () => ({ ...initialState }),
    setSelectedSession: (state, action) => {
      state.selectedSession = action.payload;
      state.currentSession =
        state.sessions.find((s) => s._id === action.payload) || null;
    },
    addSession: (state, action) => {
      // Add the new session
      state.sessions.push(action.payload);

      // Sort sessions by startDate (ascending)
      state.sessions.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate),
      );

      // Optionally make the newly added session active
      state.selectedSession = action.payload._id;
      state.currentSession = action.payload;
    },

    removeSession: (state, action) => {
      const filtered = state.sessions.filter((s) => s._id !== action.payload);
      if (state.selectedSession === action.payload) {
        if (filtered.length > 0) {
          const last = filtered[filtered.length - 1];
          state.selectedSession = last._id;
          state.currentSession = last;
        } else {
          state.selectedSession = null;
          state.currentSession = null;
        }
      }
      state.sessions = filtered;
    },
    updateSession: (state, action) => {
      // const { _id, ...updates } = action.payload;
      const index = state.sessions.findIndex(
        (s) => s._id === action.payload._id,
      );

      if (index !== -1) {
        // state.sessions[index] = { ...state.sessions[index], ...updates };
        state.sessions[index] = action.payload;
        if (state.selectedSession === action.payload._id) {
          state.currentSession = state.sessions[index];
        }
      }

      // Sort sessions by startDate (ascending)
      state.sessions.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate),
      );
    },
  },
});

export const {
  setSessions,
  removeSessions,
  setSelectedSession,
  currentSession,
  addSession,
  removeSession,
  updateSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
